import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NwcSvg = function NwcSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F1D2CF",
      d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#431413",
      fillRule: "evenodd",
      d: "M12.882 9.222 17 5.334v13.333h-3.53z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#BC2927",
      fillRule: "evenodd",
      d: "m7 5.89 3.53-.556L17 15.889l-3.53 2.778z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D33C2B",
      fillRule: "evenodd",
      d: "m7 5.89 3.53-.556v13.333H7z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#921C1E",
      fillRule: "evenodd",
      d: "m17 15.89-3.53 2.777-2.94-5.556z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#481514",
      fillOpacity: 0.6,
      fillRule: "evenodd",
      d: "m7 18.666 10-7.5L7 5.89z",
      clipRule: "evenodd"
    })]
  });
};
export var Nwc = function Nwc(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: NwcSvg
  }));
};